export default __webpack_public_path__ + "static/media/CL14.ce04330d.mp3";